import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as userDetailActions from "../redux/actions/userDetailActions";
import * as dependentActions from "../redux/actions/dependentActions";
import OneTimeSubscriptionComponent from "../components/OneTimeSubscriptionComponent";
import PopUpComponent from "../components/PopUpComponent";
import A12Y_CONST from "../common/a12yConst";
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from "@stripe/react-stripe-js";
import { secureClient } from "../config/axiosClient";

class OneTimeSubscriptionScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      stripePromiseState: null,
      showErrorPopUp: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    const stripeKey = this.props.stripeConfig?.stripe_publishable_key;
    if (stripeKey) {
      const stripePromise = loadStripe(stripeKey);
      this.setState({ stripePromiseState: stripePromise });
    }

    if (!this.props.activationFee || this.props.activationFee === "...") {
        this.props.getProration().then(res => {
            if (res && !res.success) {
                this.setState({ showErrorPopUp: true, errorMessage: res.errMsg });
            }
        });
    }
    
    if (!this.props.paymentMethod && this.props.stripeConfig?.customer_id) {
        // Option to fetch payment method if needed
    }
  }

  handleProceed = async (paymentData) => {
    this.setState({ loading: true });
    const { dependentId } = this.props.match.params;
    try {
      const body = { status: 0 };
      if (!paymentData.useExisting) {
        body.payment_method_id = paymentData.paymentMethod.id;
      }
      
      const response = await secureClient.put(
        A12Y_CONST.API_ENDPOINT.ADVOCATE_DEPENDENTS + "/" + dependentId + A12Y_CONST.API_ENDPOINT.ADVOCATE_DEPENDENTS_STATUS,
        body
      );

      if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
        // Refresh the dependent list to reflect the new status
        const advocateId = this.props.userState?.userInfo?.advocate_id || this.props.userState?.userInfo?.id;
        if (advocateId) {
          await this.props.getAllDependent(advocateId);
          await this.props.getSubscription();
        }
        this.props.history.push(A12Y_CONST.ROUTE.DASHBOARD2);
      } else {
        this.setState({
          showErrorPopUp: true,
          errorMessage: response.data.sr?.message || response.data.message || "Activation failed. Please try again."
        });
      }
    } catch (error) {
      console.error("Activation failed", error);
      this.setState({
        showErrorPopUp: true,
        errorMessage: "Activation failed. Please try again."
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCancel = () => {
    this.props.history.push(A12Y_CONST.ROUTE.DASHBOARD2);
  };

  render() {
    const { dependentId } = this.props.match.params;
    const dependent = this.props.dependentList?.find(d => d.id === dependentId);

    if (!dependent) {
        return (
            <div className="myProfileAccount animationall mainRightSidebare">
                <div className="rightPanelWidhtSidebar">
                    <div className="rightPanelWidhtSidebarContainer fullWidth padding20">
                        <h3>Dependent not found.</h3>
                        <button className="cancelButton1 marginTop20" onClick={this.handleCancel}>Back to Dashboard</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
      <div className="myProfileAccount animationall mainRightSidebare">
        <div className="rightPanelWidhtSidebar">
          <div className="rightPanelWidhtSidebarContainer fullWidth">
            {this.state.stripePromiseState ? (
              <Elements stripe={this.state.stripePromiseState} options={{appearance:{theme:"night", variables: { colorPrimary: '#2d6cb2' }}}}>
                <OneTimeSubscriptionComponent
                  dependent={dependent}
                  paymentMethod={this.props.paymentMethod}
                  onProceed={this.handleProceed}
                  onCancel={this.handleCancel}
                  loading={this.state.loading}
                  activationFee={this.props.activationFee} 
                  excemptAllFee={this.props.excemptAllFee} 
                />
              </Elements>
            ) : (
                <div className="padding20">Initializing payment gateway...</div>
            )}
          </div>
        </div>

        <PopUpComponent
          popUpStatus={this.state.showErrorPopUp}
          title="Error"
          message={this.state.errorMessage}
          buttonDeleteTxt="OK"
          buttonCancelTxt="Close"
          handleDeleteButton={() => this.setState({ showErrorPopUp: false })}
          hidePopUp={() => this.setState({ showErrorPopUp: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userState: state.userDetailReducer.userState,
  dependentList: state.dependentReducer.dependentList,
  paymentMethod: state.userDetailReducer.paymentMethod,
  stripeConfig: state.userDetailReducer.stripeConfig,
  activationFee: state.userDetailReducer.activationFee,
  excemptAllFee: state.userDetailReducer.excemptAllFee,
});

const mapDispatchToProps = (dispatch) => ({
  getProration: () => dispatch(userDetailActions.getProration()),
  getAllDependent: (advocate_id) => dispatch(dependentActions.getAllDependent(advocate_id)),
  getSubscription: () => dispatch(userDetailActions.getSubscription()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OneTimeSubscriptionScreen)
);
